var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _circle2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShibaAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.49 449.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#fff;}.cls-1{opacity:0;}.cls-2{fill:#dbd2c7;}.cls-3{fill:#d38f19;}.cls-4{fill:#c37c12;}.cls-5{fill:#ede4d6;}.cls-6{fill:#c97e1c;}.cls-7{fill:#eee9d7;}.cls-8{fill:#3b3a3a;}.cls-9{fill:#d09919;}.cls-10{fill:#743f2a;}.cls-11{fill:#f4f0e9;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 321.57,
    height: 448.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.73,216.68c-28.46-2.17-56.8-2.55-84.64.82-.54,4.85-1,9.57-1.27,14.05-2.94,45.42,50.36,76.33,60.7,90.64s11.13,82.29,11.13,82.29h23.46V317.84l-13.52-30.63S243.53,252,242.73,216.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22,276.72s11.41,70.39,12.33,115.16.92,43,.92,43h28s-7.82-120.36,9.1-162.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.15,119.85S9.92,210.46,22,276.72c0,0,65.64,26.36,96.28,30.64l106-67.06L244.91,126,136.35,106Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.53,137.59c-3,26.4-9.35,67.67-16.93,82.83,0,0,19.2,38.49,18.87,47.75s-18.15,39.19-18.15,39.19l60.81-38.45C178.56,219.69,175.07,166.24,134.53,137.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.36,240.3l4.34-72.78c-11.86,24.72-11.71,51-13.22,78.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.75,72.94s16.46,81.95,20.74,102.61S174.6,296.67,174.6,296.67L150.34,449.85H117.6s20-91.19.72-142.49-3.84-126.82-3.84-126.82l10.84-90.77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.37,236.58c37.49-61.46,21.31-124.72,21.31-124.72l-85.55,6.48c-6.57,16.51-20.16,51.6-20.7,60.77l12.1,44.18s-7.89,11.36-10.94,20.09c1.06,11.43,5.2,26.22,20,39.35,0,0,50.12,20.35,80.76,24.63,0,0,3.71-30.89,4-40.15S101.37,236.58,101.37,236.58Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,142.05s23.48,37.35,38.37,37.82,59.81-37.6,59.81-37.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.91,126s31.91,0,59.59,51.52c22.17,41.23,6.72,117.71,6.72,117.71l12.27,32-3.84,86.05H296.19s-.79-68-11.13-82.29-56.18-43.23-60.7-90.64-.12-64.55-.12-64.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.8,18.08s35.34-3,59.88,16c0,0,27.62,63,24,79.66s-37.89,57.22-93,38.95C-5.09,133.49,1,81.34,3.33,74.19S47.49,24,61.8,18.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.2,26.06S41.86-1.54,31.72,1.83c-11.91,4-9.48,49.77-9.48,49.77S51.42,41.44,59.2,26.06Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55,32S40.39,6.18,33,9.26c-7.89,3.3-8.44,41.47-8.44,41.47S43.18,43.8,55,32Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.16,86.67s3.19-7,8-6.84,9,4.74,9,4.74-3.39,5-8.49,5.19A12.4,12.4,0,0,1,87.16,86.67Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.1,77.79s.72-7-3.52-9.23-10.15-.32-10.15-.32.48,6,4.81,8.71A10.48,10.48,0,0,0,57.1,77.79Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.48,39.2c.48-.65,22.6-18.83,34.3-11.72s-8.46,55.65-8.46,55.65Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.66,29.78c9.36,5.09-8.78,50.92-8.78,50.92L122.36,52.61S135.64,23.24,147.66,29.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.58,53.59a95.34,95.34,0,0,0-3.45,16.17,94.83,94.83,0,0,0,6.21-15.33,95.34,95.34,0,0,0,3.45-16.17A94.83,94.83,0,0,0,79.58,53.59Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.26,75.23c2.45,4.61,18.39-6.11,18.39-8.25S98.73,60.78,93,61.85,84.19,73.22,85.26,75.23Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.84,126H57.67l14.76,10.88c9.48,2.36,14.74-5.53,16.06-18.17S81.4,75.59,75.23,72.91C69.9,70.6,43.51,95,38,105.79S36.68,123.86,39.84,126Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.17,69.39C60.37,73,48.71,57.7,49.4,55.67s6.65-4.29,11.78-1.42S65.83,67.83,64.17,69.39Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.07,154.54c46.14,15.29,78.32-12.49,89.48-31.13,5.45-11.55-10.33-24.61-21.87-25.54-14.33-1.17-40.12,12.67-45.6,13.93s-19.42-3.66-22-7.37S35.94,75.36,28.38,72.08C17.67,67.43,1.91,82.34,2.11,91.94,3.49,111,12.51,141.43,52.07,154.54Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.78,132.28a3.16,3.16,0,1,1-3.15-3.16A3.16,3.16,0,0,1,91.78,132.28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.69,
    cy: 115.08,
    r: 3.16
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.32,57.63s15-17.13,16.32-12.62S131,67.28,131,67.28Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.43,41.18S39.22,21.71,35.29,22.3,31.7,47.83,31.7,47.83A133.91,133.91,0,0,0,43.43,41.18Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 57.67,
    cy: 125.96,
    r: 16.31,
    transform: "translate(-44.21 32.08) rotate(-22.74)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.67,109.65A16.31,16.31,0,0,0,41.36,126c0,.09,0,.17,0,.25L57,128.74l13.62,7.14a16.29,16.29,0,0,0-12.93-26.23Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M39.84,126H57.67l14.76,10.88c9.48,2.36,14.74-5.53,16.06-18.17a52.75,52.75,0,0,0-.7-12.41c-6.39,2.67-11.58,5-13.71,5.54-5.47,1.26-19.42-3.66-22-7.37-.88-1.27-3-5.06-5.81-9.64-3.74,4.13-6.78,8.07-8.28,11C32.45,116.59,36.68,123.86,39.84,126Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M74.08,111.8a11.4,11.4,0,1,1-21.79-6.7s.92-3,11.81.36S74.08,111.8,74.08,111.8Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.15,434.84a22.91,22.91,0,0,1,45.82,0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.75,449.85a22.91,22.91,0,0,1,45.82,0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.79,404.48a22.91,22.91,0,0,1,45.82,0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.9,413.23a22.91,22.91,0,1,1,45.82,0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.35,252.25,71.29,282.19S91.7,279.55,94.35,252.25Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.44,243.38l20.09,36S31.54,263.63,33.44,243.38Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.06,127.82s-14.28,25.76-45.72,5.76-13.88-67.77,18.37-75.12,57.76,5.09,69.4,31c12.91,28.75,9.44,62.94-3.21,69.48,0,0-9.61-13.14-20-20.87S254.06,127.82,254.06,127.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibaAngry);
export default __webpack_public_path__ + "static/media/shiba-angry.80628a67c6854890e642297783ee23a6.svg";
export { ForwardRef as ReactComponent };